import {InfoCircleOutlined} from '@ant-design/icons';
import {Col, Form, Input, Select} from 'antd';
import TextArea from 'antd/es/input/TextArea';
import React from 'react';

import NumberInput from '../../../shared/NumberInput';
import {sortedOptions} from '../constants/commonFunctions';
import {inputType} from '../interface/inputType';

import QuestionnaireSwitch from './QuestionnaireSwitch';

const InputGrid: React.FC<{
  field: any;
}> = ({field}) => {
  const {NUMBER_COL, TEXTAREA_COL, TEXT_COL} = inputType;

  const tooltipCSS = {
    width: 'auto',
    maxWidth: '500px',
    height: 'auto',
    padding: '12px'
  };

  switch (field.fieldType) {
    case TEXT_COL:
      return (
        <Col span={12}>
          <Form.Item
            labelCol={{span: 24}}
            name={field.fieldName}
            label={field.fieldLabel}
            tooltip={
              field.tooltip
                ? {title: field.tooltip, icon: <InfoCircleOutlined />}
                : ''
            }
          >
            <Input />
          </Form.Item>
        </Col>
      );
    case TEXTAREA_COL:
      return (
        <Col span={24}>
          <Form.Item
            labelCol={{span: 24}}
            name={field.fieldName}
            label={field.fieldLabel}
            tooltip={
              field.tooltip
                ? {title: field.tooltip, icon: <InfoCircleOutlined />}
                : ''
            }
          >
            <TextArea
              style={{verticalAlign: 'top'}}
              autoSize={{minRows: 4, maxRows: 10}}
            />
          </Form.Item>
        </Col>
      );
    case NUMBER_COL:
      return (
        <Col span={12}>
          <Form.Item
            name={field.units ? [field.fieldName, 'value'] : field.fieldName}
            label={field.fieldLabel}
            labelCol={{span: 24}}
            tooltip={
              field.tooltip
                ? {
                    title: field.tooltip,
                    icon: <InfoCircleOutlined />,
                    overlayStyle: tooltipCSS
                  }
                : ''
            }
          >
            <NumberInput
              min={field.min}
              max={field.max}
              defaultValue={field.defaultValue}
              placeholder={field.placeHolder}
              disabled={field.disabled}
              isFormatted={field?.isFormatted}
              addonAfter={
                !field.units ? null : typeof field.units === 'string' ? (
                  <Form.Item
                    name={field.units && [field.fieldName, 'unit']}
                    initialValue={field.units}
                    noStyle
                  >
                    {field.units}
                  </Form.Item>
                ) : (
                  <Form.Item
                    name={field.units && [field.fieldName, 'unit']}
                    noStyle
                  >
                    <Select
                      style={{width: 140}}
                      placeholder="Select Unit"
                      options={sortedOptions(field.units)}
                    />
                  </Form.Item>
                )
              }
            />
          </Form.Item>
        </Col>
      );

    default:
      return (
        <Col span={24}>
          <QuestionnaireSwitch field={field} />
        </Col>
      );
  }
};

export default InputGrid;
